import TResource from './t-resource.vue'

export default TResource
